import axios from "axios";
import moment from "moment";
import "moment/dist/locale/th";
import { getCurrentInstance } from "vue";
import StatusModal from "./components/Modals/StatusModal.vue";

export const globalProperties = (app) => {
  app.config.globalProperties.$moment = moment;

  // main.js
  app.config.globalProperties.$validateMsg = function (errorObj, errors) {
    // เคลียร์ errors
    Object.keys(errors).forEach((key) => {
      errors[key] = "";
    });
    // วนลูป errors ที่ได้จาก backend
    Object.keys(errorObj).forEach((key) => {
      const messages = errorObj[key];
      // const newKey = key.replace(/\.(\d+)/g, "[$1]");
      if (Array.isArray(messages) && messages.length > 0) {
        errors[key] = messages[0];
      } else {
        console.warn(`Unexpected error format for key: ${key}`, errorObj[key]);
      }
    });
  };

  //date format (12 เม.ย 2568)
  app.config.globalProperties.$formatDate1 = function (val) {
    if (!val) return "";
    const formatted = moment(val)
      .locale("th")
      .add(543, "years")
      .format("D MMM YYYY");
    return formatted;
  };
  //date format (29-12-2568)
  app.config.globalProperties.$formatDate2 = function (val) {
    if (!val) return "";
    const formatted = moment(val).add(543, "years").format("DD-MM-YYYY");
    return formatted;
  };
  //date format (29-12-2568)
  app.config.globalProperties.$formatDate21 = function (val) {
    if (!val) return "";
    const formatted = moment(val).format("DD-MM-YYYY");
    return formatted;
  };
  //date format (2025-06-01)
  app.config.globalProperties.$formatDate3 = function (val) {
    if (!val) return "";
    const formatted = moment(val).format("YYYY-MM-DD");
    return formatted;
  };
  //date format (20 สิงหาคม 2500)
  app.config.globalProperties.$formatDate4 = function (val) {
    if (!val) return "";
    const formatted = moment(val)
      .add(543, "years")
      .locale("th")
      .format("D MMMM YYYY");
    return formatted;
  };
  //date format (03/03/2568)
  app.config.globalProperties.$formatDate5 = function (val) {
    if (!val) return "";
    const formatted = moment(val).add(543, "years").format("DD/MM/YYYY");
    return formatted;
  };

  app.config.globalProperties.$numberAndComma = function (val) {
    if (!val) return "";
    // ถ้า val เป็นตัวเลข หรือเป็น string ที่เป็นตัวเลข
    if (!isNaN(val)) {
      return Number(val).toLocaleString("en-US"); // เช่น 1000 => 1,000
    }
  };
  //คำนวณอายุ
  app.config.globalProperties.$CalAge = function (val) {
    if (!val) return "";
    const birthDate = new Date(val);
    const age = moment().diff(moment(birthDate), "years");
    return age;
  };
  //time format (08.00)
  app.config.globalProperties.$formatTime1 = function (val) {
    if (!val) return "";
    const time = moment(val).format("HH.mm");
    return time;
  };
  //form
  app.config.globalProperties.$buildFormData = function (
    formData,
    dataJson,
    parentKey
  ) {
    if (
      dataJson &&
      typeof dataJson === "object" &&
      !(dataJson instanceof Date) &&
      !(dataJson instanceof File) &&
      !(dataJson instanceof Blob)
    ) {
      Object.keys(dataJson).forEach((key) => {
        app.config.globalProperties.$buildFormData(
          formData,
          dataJson[key],
          parentKey ? `${parentKey}[${key}]` : key
        );
      });
    } else {
      const value = dataJson == null ? "" : dataJson;
      formData.append(parentKey, value);
    }
    return formData;
  };
  // input only english
  app.config.globalProperties.$checkEnglishInput = function (event) {
    const regex = /^[\x00-\x7F]$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  };
  // validate user
  app.config.globalProperties.$validateUserForm = function (inputValue) {
    const regex = /^[a-zA-Z0-9._@-]*$/;
    if (!regex.test(inputValue)) {
      inputValue = inputValue.slice(0, -1);
    }
    return inputValue;
  };
  // validate phone
  app.config.globalProperties.$validateInputPhoneNum = function (inputValue) {
    var regex = /^\d{0,10}$/;
    if (!regex.test(inputValue)) {
      inputValue = inputValue.slice(0, -1);
    }
    return inputValue;
  };

  app.config.globalProperties.$convertToBuddhistYear = function (
    date,
    onlyDate
  ) {
    return date
      ? moment(date).format("DD/MM/") +
      (moment(date).year() + 543) +
      (onlyDate ? "" : " " + moment(date).format("HH:mm"))
      : "-";
  };
};

export const $validateInputOneDigit = function (inputValue, decimalPlaces) {
  inputValue = String(inputValue);
  inputValue = inputValue.replace(/[^0-9.]/g, "");
  const parts = inputValue.split(".");
  if (parts.length > 2) {
    inputValue = parts[0] + "." + parts.slice(1).join("");
  }
  if (inputValue.includes(".")) {
    const [intPart, decPart] = inputValue.split(".");
    inputValue = intPart + "." + (decPart ? decPart.slice(0, decimalPlaces) : "");
  }
  return inputValue;
};

export async function downloadFile(url, downloadFilename) {
  try {
    const response = await axios.get(url, {
      responseType: "blob",
    });

    const blob = response.data;
    const contentDisposition = response.headers["content-disposition"];
    let filename = downloadFilename || "downloaded_file";

    if (contentDisposition) {
      const filenameStarMatch = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)/i
      );
      if (filenameStarMatch && filenameStarMatch[1]) {
        filename = decodeURIComponent(filenameStarMatch[1]);
      } else {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i
        );
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "").trim();
        }
      }
    }

    if (filename && !filename.includes(".")) {
      const mimeType = blob.type;
      let extension = "";
      switch (mimeType) {
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          extension = ".xlsx";
          break;
        case "application/vnd.ms-excel":
          extension = ".xls";
          break;
        case "text/csv":
          extension = ".csv";
          break;
        case "application/pdf":
          extension = ".pdf";
          break;
        case "text/plain":
          extension = ".txt";
          break;
        case "application/json":
          extension = ".json";
          break;
        case "application/msword":
          extension = ".doc";
          break;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          extension = ".docx";
          break;
        default:
          extension = ".txt";
      }
      filename += extension;
    }
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error("Download failed:", error);
  }
}

export const toggleDataSource = async (
  disasterName,
  toggleState,
  statusModalRef,
  refresh
) => {
  try {
    const res = await axios.post("/config-disaster", {
      [disasterName]: toggleState ? 1 : 0,
    });
    if (statusModalRef) {
      statusModalRef.openModal("success", {
        subHeader: res.data.message,
      });
    }
    await refresh();
    return res.data;
  } catch (error) {
    throw error;
  }
};
